export default __webpack_public_path__ + "static/media/commonocean-search-code-example.e40a8348.md";